import { getHeaders } from './utils';

export const SaveSettings = (token: string, meeting: number, settings: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/settings`, {
	method: 'POST',
	headers: getHeaders(token) as any,
	body: JSON.stringify({
		meeting,
		settings,
	}),
}).then((res) => res.ok).catch((error) => {
	console.error(error);
});

export const GetUser = (token: string, email: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/home/find-user`, {
	method: 'POST',
	headers: getHeaders(token) as any,
	body: JSON.stringify({
		email,
	}),
}).then((res) => {
	if (res.ok) {
		return res.json();
	}
	return null;
}).catch((error) => {
	console.error(error);
});

export const UpdateTutorialVideoCount = (token: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/tutorial-video`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
	}).then(res => {
		if (res.ok) {
			return res.json();
		}
	}).catch(error => {
		console.error(error);
	});
};

export const UserExists = (email: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/user-exists`, {
	method: 'POST',
	headers: getHeaders() as any,
	body: JSON.stringify({
		email,
	}),
}).then((res) => {
	if (res.ok) {
		return res.json();
	}
	return null;
}).catch((error) => {
	console.error(error);
});
